/**
 * Postmaster-SOC Fixture.
 * Spec: lmm-wiki/wiki/orbit-specs/nexus-postmaster-soc.md
 */

const NOW = Date.now();
const INCIDENTS = [
  {
    id: 1,
    ip_address: '198.51.100.42',
    provider: 'microsoft',
    status: 'listed',
    detected_at: new Date(NOW - 2 * 3600_000).toISOString(),
    cleared_at: null,
    evidence: { code: '5.7.511', raw: 'Access denied; blocked by reputation' },
  },
  {
    id: 2,
    ip_address: '198.51.100.17',
    provider: 'spamhaus',
    status: 'mitigation_active',
    detected_at: new Date(NOW - 6 * 3600_000).toISOString(),
    cleared_at: null,
    evidence: { code: 'SBL', raw: 'Listed on SBL422123' },
  },
  {
    id: 3,
    ip_address: '198.51.100.33',
    provider: 'microsoft',
    status: 'delisting_requested',
    detected_at: new Date(NOW - 18 * 3600_000).toISOString(),
    cleared_at: null,
    evidence: { code: '5.7.511', raw: 'Access denied; please use S1110' },
  },
  {
    id: 4,
    ip_address: '198.51.100.91',
    provider: 'barracuda',
    status: 'cleared',
    detected_at: new Date(NOW - 36 * 3600_000).toISOString(),
    cleared_at: new Date(NOW - 12 * 3600_000).toISOString(),
    evidence: { code: 'BRBL', raw: 'IP cleared after manual review' },
  },
];

export function postmasterIncidentsFixture({ status, provider, ip } = {}) {
  let list = INCIDENTS;
  if (status) list = list.filter((i) => i.status === status);
  if (provider) list = list.filter((i) => i.provider === provider);
  if (ip) list = list.filter((i) => i.ip_address.includes(ip));
  return { incidents: list };
}
